import {AnyEvent, JOB_LOADED_EVENT, JobLoadedEvent} from '../type';

export default function jobLoaded(payload: JobLoadedEvent['payload']): AnyEvent {
  return {
    type: JOB_LOADED_EVENT,
    payload,
  }
}